import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AttributesHome from './Index.vue';
import AttributeForm from './AttributeForm.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'attributes_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'attributes_list',
          component: AttributesHome,
          meta,
        },
        {
          path: 'new',
          name: 'attributes_new',
          component: AttributeForm,
          meta,
        },
        {
          path: ':attributeId/edit',
          name: 'attributes_edit',
          component: AttributeForm,
          meta,
          props: route => ({ attributeId: Number(route.params.attributeId) }),
        },
      ],
    },
  ],
};
